import * as angular from "angular";
import {BranchModel} from "../models/branch.model";
import {GroupModel} from "../../groups/models/group.model";
import * as _ from "lodash";

export class BranchesDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private $log, private $branches) {
  }

  // ******************************
  // External methods
  // ******************************

  createBranch(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-branch-dialog.html').default,
      controller: function ($scope) {

        $scope.branch = {
          tags: []
        };

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        // External methods
        // ******************************

        $scope.onTagsChange = (tags: string[]) => {
          $scope.branch.tags = tags;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.branch);
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  editBranch(event, branch: BranchModel) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-branch-dialog.html').default,
      controller: function ($scope) {

        $scope.branch = angular.copy(branch);
        $scope.cancel = self.$mdDialog.cancel;

        $scope.onTagsChange = (tags: string[]) => {
          $scope.branch.tags = tags;
        }

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.branch);
            }

          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  branchSelect(event, excludeBranchIds) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true,
      template: require('./../views/dialogs/branch-select-dialog.html').default,
      controller: function ($scope) {

        $scope.excludeBranchIds = excludeBranchIds;
        $scope.selectedBranchId = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        //         Public methods
        // ******************************

        $scope.onBranchIdChange = (branchId) => {
          $scope.selectedBranchId = branchId;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid && $scope.selectedBranchId) {
              self.$mdDialog.hide($scope.selectedBranchId)
            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> BranchesDialogService@branchesSelect @submit')
          }

        }

      }
    })
  }

  branchesSelect(event, excludeBranchIds?: string[], branchesIds?: string[]) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true,
      template: require('./../views/dialogs/branches-select-dialog.html').default,
      controller: function ($scope, $branches) {

        $scope.excludeBranchIds = excludeBranchIds;
        $scope.branchIds = branchesIds || [];
        $scope.groups = [];
        $scope.groupBranchIds = [];
        $scope.branchesRef = $branches();

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        //         Public methods
        // ******************************

        if (branchesIds?.length) {
          $scope.branchesRef.$asyncValues(branchesIds)
            .then((branches: BranchModel[]) => {
              $scope.selectedBranchChips = $scope.branchesToChip(branches);
            });
        }

        $scope.branchesToChip = (branches) => {
          return _.map(branches, (branch) => {
            return {name: branch.name, id: branch.id};
          });
        }

        $scope.onBranchIdsChange = (branchIds) => {
          $scope.branchIds = branchIds;

          if (!!branchIds?.length) {
            $scope.branchesRef.$asyncValues(branchIds)
              .then((branches: BranchModel[]) => {
                $scope.selectedBranchChips = $scope.branchesToChip(branches);
              });
          } else {
            $scope.selectedBranchChips = [];
          }
        }

        $scope.onClearBranches = () => {
          $scope.branchIds = [];
          $scope.selectedBranchChips = [];
        }

        $scope.onRemoveBranchChip = (branch) => {
          $scope.branchIds = _.filter($scope.branchIds, (id) => {
            return id !== branch.id;
          });

          $scope.selectedBranchChips = $scope.selectedBranchChips.filter((chip) => chip.id !== branch.id);
        }


        $scope.onChangeFilterGroups = (groups) => {
          $scope.groups = groups;
          $scope.groupBranchIds = [];
          groups?.forEach((g: GroupModel) => {
            if (g.branchIds?.length) {
              $scope.groupBranchIds = _.uniq($scope.groupBranchIds.concat(g.branchIds));
            }
          });
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.branchIds)
            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> BranchesDialogService@branchesSelect @submit')
          }

        }

      }
    })
  }

  addBranchPrograms(event, programTypes, branchConfiguration) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-branch-programs-dialog.html').default,
      controller: function ($scope, $mdSelect) {

        $scope.programTypesRef = angular.copy(programTypes);
        $scope.programTypesRef = programTypes.map(p => {
          return {
            id: p.id,
            type: p.name,
          }
        })
        $scope.branchConfigurationRef = angular.copy(branchConfiguration);
        $scope.selectedProgramsRef = angular.copy($scope.branchConfigurationRef.programTypes)
        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        // External methods
        // ******************************

        $scope.onProgramTypesChange = (programTypes) => {
          $scope.selectedProgramsRef = angular.copy(programTypes);
        }

        $scope.onResetSelect = () => {
          $scope.selectedProgramsRef = [];
          $mdSelect.hide();
        }

        $scope.onCancelSelect = () => {
          $scope.selectedProgramsRef = angular.copy($scope.branchConfigurationRef.programTypes);
          $mdSelect.hide();
        }

        $scope.onSubmitSelect = () => {
          $scope.branchConfigurationRef.programTypes = $scope.selectedProgramsRef;
          $mdSelect.hide();
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              $scope.branchConfigurationRef.programTypes = $scope.selectedProgramsRef;
              self.$mdDialog.hide($scope.branchConfigurationRef);
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  editTags(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-branch-tag-dialog.html').default,
      controller: function ($scope) {

        $scope.tags = [];

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        // External methods
        // ******************************

        $scope.onTagsChange = (tags: string[]) => {
          $scope.tags = tags;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.tags);
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }


}

angular
  .module('bringoz.admin.branches')
  .service('branchesDialogService', BranchesDialogService);
